/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getOnboardingSuggestedUsersSkeleton.defs'
export { main as default } from './getOnboardingSuggestedUsersSkeleton.defs'
